import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { AngularFireStorage } from "@angular/fire/storage";
import { finalize } from 'rxjs/operators';
import { NgxPicaService, NgxPicaResizeOptionsInterface } from 'ngx-pica';
import { AuthService } from "app/core/auth.service";


@Component({
  selector: 'ng-upload-profile-img',
  templateUrl: './upload-profile-img.component.html',
  styleUrls: ['./upload-profile-img.component.scss']
})
export class UploadProfileImgComponent implements OnInit {

  @Input()
  parent: FormControl;

  @Input()
  url: string = '';

  constructor(
    private storage: AngularFireStorage,
    private _matSnackBar: MatSnackBar,
    private _ngxPicaService: NgxPicaService,
    private authService: AuthService
  ) { 
  }

  get uid() {
    return this.authService.user.uid;
  }

  ngOnInit() {
  }

  get control() {
    return this.parent;
  }

  fileChangeEvent(event: any): void {
    const file: File = event.target.files[0];
    const options: NgxPicaResizeOptionsInterface = {
      aspectRatio: {
        keepAspectRatio: true
      }
    };
      
    this._ngxPicaService.resizeImage(file, 250, 250, options).subscribe((imageResized: File) => {
      const id = Math.random().toString(36).substring(2);
      const filePath = `uploads/profile/${this.uid}/img_${id}`;
  
      const ref = this.storage.ref(filePath);
      const task = this.storage.upload(filePath, imageResized);

      task.snapshotChanges().pipe(finalize(() => {
        // Set control value
        ref.getDownloadURL().subscribe(val => {
           this.parent.patchValue({
            photoUrl: val
          });
          this.url = val;
          this._matSnackBar.open('Agregada una imagen al formulario, recuerda guardar', '', {
            duration: 3000,
          });
        })
      })).subscribe();
    })
  }

  removeImage() {
    this.url = ''
    this.parent.patchValue({
      photoUrl: ''
    });

    this._matSnackBar.open('Imagen removida, recuerda guardar', '', {
      duration: 3000,
    });
  }
}
